import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { ButtonGroup, ImagePicker } from "@caelor/ui";
import Add from "../../../../../../features/cards-v2/components/actions/icons/Add";
import Trash from "../../../../../../features/cards-v2/components/actions/icons/Trash";
import ArrowLeft from "../../../../../../features/cards-v2/components/actions/icons/ArrowLeft";
import ArrowRight from "../../../../../../features/cards-v2/components/actions/icons/ArrowRight";
import { TextInput as Text } from "@caelor/ui";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionActionContainer,
  SettingsOptionBackButton,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../styles";
import { useImageSliderStore } from "../../../../../../stores/use-image-slider-store";
import { BOOLEAN_OPTIONS, CORNERS_OPTIONS } from "./options";
import { DESIGNS_OPTIONS, IMAGE_SLIDER_PROP } from "./defaults";
import {
  EmptyMessage,
  SliderImagePreview,
  SliderImagePreviewActions,
  SliderImagePreviewButton,
  SliderImagePreviewContainer,
  SliderImagesPreview,
} from "./styles";
import { DEFAULT_IMAGE_CONTENT } from "../../../templates/features/image-slider/image-slider-templates";

const ImagesSliderOptions = () => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePickerOpen, setImagePickerOpen] = useState(false);

  const { data, setData, moveImage, setImage } = useImageSliderStore(
    (state) => ({
      data: state.data,
      setData: state.setData,
      moveImage: state.moveImage,
      setImage: state.setImage,
    })
  );

  const { t } = useTranslation();

  const hasContent = data.hasImagesTitle || data.hasImagesDescription;
  return (
    <>
      {/* {hasContent && (
        <SettingsOptionContainer>
          <SettingsOptionHeading>{t("alignment")}</SettingsOptionHeading>

          <OptionContainer>
            <OptionLabel>{t("align")}</OptionLabel>
            <OptionContent>
              <ButtonGroup
                items={ALIGNMENT_OPTIONS}
                value={
                  data[IMAGE_SLIDER_PROP.ADVANCED_OPTIONS][
                    IMAGE_SLIDER_PROP.TEXT_ALIGNMENT
                  ]
                }
                onClick={(value) => {
                  setData({
                    [IMAGE_SLIDER_PROP.ADVANCED_OPTIONS]: {
                      ...data[IMAGE_SLIDER_PROP.ADVANCED_OPTIONS],
                      [IMAGE_SLIDER_PROP.TEXT_ALIGNMENT]: value,
                      [IMAGE_SLIDER_PROP.TITLE_ALIGNMENT]: value,
                    },
                  });
                }}
              />
            </OptionContent>
          </OptionContainer>
        </SettingsOptionContainer>
      )} */}

      <SettingsOptionContainer>
        <SettingsOptionHeading>
          {t("flexible-display-items")}
        </SettingsOptionHeading>

        {DESIGNS_OPTIONS.TITLE.includes(data.design) && (
          <OptionContainer>
            <OptionLabel>{t("title")}</OptionLabel>
            <OptionContent>
              <ButtonGroup
                items={BOOLEAN_OPTIONS}
                value={data[IMAGE_SLIDER_PROP.HAS_IMAGES_TITLE]}
                onClick={(value) =>
                  setData({ [IMAGE_SLIDER_PROP.HAS_IMAGES_TITLE]: value })
                }
                i18n={t}
              />
            </OptionContent>
          </OptionContainer>
        )}

        {DESIGNS_OPTIONS.SUBTEXT.includes(data.design) && (
          <OptionContainer>
            <OptionLabel>{t("subtext")}</OptionLabel>
            <OptionContent>
              <ButtonGroup
                items={BOOLEAN_OPTIONS}
                value={data[IMAGE_SLIDER_PROP.HAS_IMAGES_DESCRIPTION]}
                onClick={(value) =>
                  setData({ [IMAGE_SLIDER_PROP.HAS_IMAGES_DESCRIPTION]: value })
                }
                i18n={t}
              />
            </OptionContent>
          </OptionContainer>
        )}
      </SettingsOptionContainer>

      {DESIGNS_OPTIONS.CONTENT.includes(data.design) && hasContent && (
        <SettingsOptionContainer>
          <SettingsOptionHeading>{t("content")}</SettingsOptionHeading>

          <OptionContainer>
            <OptionLabel>{t("title")}</OptionLabel>
            <OptionContent>
              <Text
                placeholder={t("add")}
                value={data[IMAGE_SLIDER_PROP.TITLE]}
                onChange={(value) =>
                  setData({ [IMAGE_SLIDER_PROP.TITLE]: value })
                }
              />
            </OptionContent>
          </OptionContainer>
        </SettingsOptionContainer>
      )}

      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("styling-options")}</SettingsOptionHeading>

        <OptionContainer>
          <OptionLabel>{t("corners")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={CORNERS_OPTIONS}
              value={
                data[IMAGE_SLIDER_PROP.ADVANCED_OPTIONS][
                  IMAGE_SLIDER_PROP.BORDER_RADIUS
                ]
              }
              options={{ input: true }}
              onClick={(value) =>
                setData({
                  [IMAGE_SLIDER_PROP.ADVANCED_OPTIONS]: {
                    ...data[IMAGE_SLIDER_PROP.ADVANCED_OPTIONS],
                    [IMAGE_SLIDER_PROP.BORDER_RADIUS]: value,
                  },
                })
              }
              onChange={({ target: { value } }) => {
                if (value.length < 4) {
                  setData({
                    [IMAGE_SLIDER_PROP.ADVANCED_OPTIONS]: {
                      ...data[IMAGE_SLIDER_PROP.ADVANCED_OPTIONS],
                      [IMAGE_SLIDER_PROP.BORDER_RADIUS]: value,
                    },
                  });
                }
              }}
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
      <SettingsOptionContainer>
        <SettingsOptionActionContainer>
          <SettingsOptionHeading>{t("images")}</SettingsOptionHeading>
          <SettingsOptionBackButton>
            <ImagePicker
              asParent={true}
              image={selectedImages}
              open={imagePickerOpen}
              hideCurrentPage={false}
              setOpen={setImagePickerOpen}
              hasImageReposition={false}
              onClose={() => {
                const imagesWithContent = selectedImages.map(
                  (selectedImage) => ({
                    ...selectedImage,
                    title: DEFAULT_IMAGE_CONTENT.title,
                    description: DEFAULT_IMAGE_CONTENT.description,
                  })
                );
                setData({
                  [IMAGE_SLIDER_PROP.IMAGES]: [
                    ...data[IMAGE_SLIDER_PROP.IMAGES],
                    ...imagesWithContent,
                  ],
                });
                setSelectedImages([]);
              }}
              onChange={(value) =>
                setSelectedImages((previousState) => {
                  const exists = previousState.some(
                    (img) => img.id === value.id
                  );

                  if (exists) {
                    return previousState.filter((img) => img.id !== value.id);
                  } else {
                    return [...previousState, value];
                  }
                })
              }
              imageReposition={false}
              isWrapper={true}
              tabs={["Unsplash", "From page", "Link", "Upload"]}
              sidebarContainerStyles={{}}
              thumbnailContainerStyles={{}}
              libraryImages={[]}
              iconLibraryImages={[]}
              hideInfo={true}
            >
              <Add />
            </ImagePicker>
          </SettingsOptionBackButton>
        </SettingsOptionActionContainer>
        {!!data[IMAGE_SLIDER_PROP.IMAGES].length ? (
          <SliderImagesPreview>
            {data[IMAGE_SLIDER_PROP.IMAGES].map((image) => (
              <SliderImagePreviewContainer onClick={() => setImage(image)}>
                <SliderImagePreviewActions
                  onClick={(event) => event.stopPropagation()}
                >
                  <SliderImagePreviewButton
                    onClick={() => {
                      const images = data[IMAGE_SLIDER_PROP.IMAGES].filter(
                        (filterImage) => filterImage.id !== image.id
                      );
                      setData({
                        [IMAGE_SLIDER_PROP.IMAGES]: images,
                      });
                    }}
                  >
                    <Trash />
                  </SliderImagePreviewButton>
                  {data[IMAGE_SLIDER_PROP.IMAGES].length > 1 && (
                    <>
                      <SliderImagePreviewButton
                        onClick={() => moveImage(image.id, "left")}
                      >
                        <ArrowLeft />
                      </SliderImagePreviewButton>
                      <SliderImagePreviewButton
                        onClick={() => moveImage(image.id, "right")}
                      >
                        <ArrowRight />
                      </SliderImagePreviewButton>
                    </>
                  )}
                </SliderImagePreviewActions>
                <SliderImagePreview src={image.link} alt={image?.title} />
              </SliderImagePreviewContainer>
            ))}
          </SliderImagesPreview>
        ) : (
          <EmptyMessage>
            {t("you-have-no-selected-images-in-the-gallery")}
          </EmptyMessage>
        )}
      </SettingsOptionContainer>
    </>
  );
};

export default ImagesSliderOptions;
